module.exports = __webpack_public_path__ + "assets/img/favorite_icon.677c14ed.png";